import * as React from "react";
import { Modal } from "react-bootstrap";
import { connect } from 'react-redux';
import { navigateTo } from "../../../actions/navigationActions";
import { hideModal } from "../../../actions/salesModalActions";
import { DASHBOARD } from "../../../routes/routes";
import '../../Modals/Modal.css';

class ModalSalesComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {};
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleHideModal = this.handleHideModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleSubmitModal = this.handleSubmitModal.bind(this);
        this.handleExitQuote = this.handleExitQuote.bind(this);
        this.handleButtonEvent = this.handleButtonEvent.bind(this);
    }

    handleShowModal(e: any) { }
    
    handleSubmitModal(e: any) {
        const { modal } = this.props;
        if (modal.modalProps.okButtonEvent != undefined) {
            modal.modalProps.okButtonEvent();
        }

        this.props.dispatchAction(hideModal());
    }
   
    handleHideModal(e: any) {
        this.props.dispatchAction(hideModal());
    }

    handleExitQuote(e: any) {
        this.props.dispatchAction(hideModal());
        this.props.dispatchAction(navigateTo(DASHBOARD));
    }
    
    handleCloseModal(e: any) {
        const { modal } = this.props;
        if (modal.modalProps.cancelButtonText === '') {
            this.handleSubmitModal(e);
        }
        else {
            this.handleHideModal(e);
        }
    }

    async handleButtonEvent(buttonEvent: Function) {
        this.props.dispatchAction(hideModal());

        if (buttonEvent) {
            await buttonEvent();
        }
    }

    render() {
        const { modal } = this.props;
        let header = () =>
            <>
                <div className="text-center">
                    <img src={modal.modalProps.titleImage} className="mb-3" />
                    <h3 className="m-0">
                        {modal.modalProps.titleText}
                    </h3>
                </div>
                {(modal.modalProps.showClose ?? true) !== false && 
                <div style={{ position: "absolute", right: "24px", top: "24px" }}>
                    <button className="btn-modal-close" onClick={this.handleCloseModal}><img src="./images/icons-navigation-close-16-px-dark-grey.svg" alt="close" title="close" /></button>
                    </div>
                }
            </>

        let hasBody = (modal.modalProps.body.length > 0);
        let body = () =>
            <div className="text-center w-100" dangerouslySetInnerHTML={{ __html: modal.modalProps.body }} />

        let footer = () => {
            let content: any = <></>;
            let buttons: any = <></>;

            if (modal.modalProps.buttons?.length > 0) {
                buttons = modal.modalProps.buttons.map((item) => {
                    return <button className={item.className ?? "w-100 btn btn-solid-red"} onClick={() => this.handleButtonEvent(item.event)}>
                        {item.text}
                    </button>
                })
            }
            else {
                buttons = <>
                    <button className={modal.modalProps.okButtonStyle !== undefined && modal.modalProps.okButtonStyle !== '' ? modal.modalProps.okButtonStyle : "w-100 btn btn-solid-red"} onClick={this.handleSubmitModal}>
                        {modal.modalProps.okButtonText}
                    </button>

                    {modal.modalProps.cancelButtonText !== undefined && modal.modalProps.cancelButtonText !== '' &&
                        <button className="w-100 btn btn-outline-red mt-3" style={{ fontWeight: "bold" }} onClick={this.handleExitQuote}>
                            {modal.modalProps.cancelButtonText}
                        </button>
                    }
                </>
            }

            content = <>
                {buttons}
                <div className="text-center w-100" dangerouslySetInnerHTML={{ __html: modal.modalProps.footer }} />
            </>;

            return content;
        }

        

        return (
            <Modal
                show={modal.visible}
                onHide={this.handleHideModal}
                backdrop="static"
                keyboard={false}
                centered
                animation={false}
                onEnter={this.handleShowModal}
                onShow={this.handleShowModal}
                className=""
            >
                <Modal.Header className="col-12 text-center no-border pb-0">
                    <Modal.Title className="w-100">
                        {header()}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className={hasBody ? "pt-3 pb-3" : ""}>
                    {body()}
                    <div className="warranty-questions-hr w-100 mt-3"></div>
                </Modal.Body>

                <Modal.Footer className="border-0 pt-0">
                    
                    {footer()}
                </Modal.Footer>

            </Modal>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        modal: state.modalSales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return { dispatchAction: (e) => dispatch(e) }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSalesComponent)
